/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React, {useEffect, useState} from "react";
import {Button, Card, Pagination} from "antd";
import {GlobalAPIRoutes, PublicAPIRoutes} from "../../api/APIRoutes";
import placeholder from "../../assets/images/placeholder.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle} from "@fortawesome/free-solid-svg-icons";
import {getData} from "../../api/Interface";
import {useLocation, useHistory} from "react-router-dom";

export default function VideogramList() {

    const [videograms, setVideograms] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();


    useEffect(() => {
        getItems();
    }, [query.get("page")]);

    const getItems = async () => {
        setLoading(true);
        let response = await getData(`${PublicAPIRoutes.GetVgItems}?page=${(query.get("page") || 1)}`);
        if (response) {
            setVideograms(response.data);
        }
        setLoading(false)
    };

    return (
        <div className="row py-3">

            {!loading && videograms.data && videograms.data.map((item, key) =>
                <div className="col-md-4 col-sm-4 col-6 my-3" key={key}>
                    <Card
                        className="heif-8 heif-md-6 heif-lg-6 heif-xl-6 b-15 my-2 my-sm-0"
                        hoverable
                        cover={
                            <>
                                <img className="img-fluid bt-15 img-card"
                                     src={item.thumb_image !== null ?
                                         item.thumb_image.s3_status === 2
                                             ? item.thumb_image.s3_file
                                             :  item.thumb_image.url
                                         : placeholder
                                     }/>
                            </>
                        }
                        onClick={() => history.push(`/videogram/${item.id}`)}
                    >
                        <div className="txt-right pb-5">
                            <span className="text-muted"><FontAwesomeIcon icon={faCircle}
                                                                        size="sm"/> {item.title}</span>
                        </div>
                        <div className="col-12 text-center card-footer">
                            <Button
                                className="col-12"
                                size={"middle"}
                                type={"primary"}
                            >مشاهده</Button>
                        </div>
                    </Card>
                </div>
            )}

            <div className="col-12 text-center my-3">
                {videograms && videograms.data && videograms.last_page &&
                <Pagination
                    style={{direction: 'ltr', padding: 10}}
                    size="small"
                    total={videograms.total}
                    current={query.get("page") ? parseInt(query.get("page")) : 1}
                    onChange={e => {
                        history.push(`${history.location.pathname}?page=${e}`)
                    }}
                />
                }
            </div>

        </div>
    )
}